export function articleListHover() {
    $('.article-list .item .image a, .article-list .item h4 a').hover(function () {
        if ($('body').hasClass("no-touch")) {
            $(this).closest('.item').addClass('hovered');
        }
    }, function () {
        $('.article-list .item').removeClass('hovered');
    });

    $('.article-heading .image a, .article-heading h1, .article-heading .h1').hover(function () {
        if ($('body').hasClass("no-touch")) {
            $(this).closest('.article-heading').addClass('hovered');
        }
    }, function () {
        $('.article-heading').removeClass('hovered');
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/articleListHover.js